import type { CheckoutSession } from "@/API";
import type { State } from "@/types/common";
import { create } from "zustand";
import { generateClient, type GraphQLResult } from "aws-amplify/api";
import { createCheckoutSession as createCheckoutSessionMutation } from "@/graphql/mutations";
import type { GraphQLError } from "graphql";

const client = generateClient();

export const createCheckoutSessionState = create<State<CheckoutSession>>(
  () => ({
    data: null,
    isLoading: false,
    error: null,
    isFetching: false,
  }),
);

export const createCheckoutSessionIsloading = () =>
  createCheckoutSessionState.setState(() => ({
    isLoading: true,
    data: null,
    error: null,
  }));
export const createCheckoutSessionIsError = (error: GraphQLError[]) =>
  createCheckoutSessionState.setState(() => ({
    error: error,
    data: null,
    isLoading: false,
  }));
export const createCheckoutSessionIsSuccess = (
  checkoutSession: CheckoutSession,
) =>
  createCheckoutSessionState.setState(() => ({
    data: checkoutSession,
    isLoading: false,
    error: null,
  }));

export type CreateCheckoutSessionParams = {
  priceId: string;
  isSetup?: boolean;
  quantity?: number;
};

export const createCheckoutSession = async ({
  priceId,
  isSetup,
  quantity,
}: CreateCheckoutSessionParams) => {
  createCheckoutSessionIsloading();

  try {
    const { data } = await client.graphql({
      query: createCheckoutSessionMutation,
      variables: {
        isLocalhost: import.meta.env.VITE_DOMAIN_NAME === "localhost:5173",
        priceId,
        setup: isSetup ?? false,
        quantity,
      },
    });

    createCheckoutSessionIsSuccess(
      data.createCheckoutSession as CheckoutSession,
    );
  } catch (e: unknown) {
    const graphQl = e as GraphQLResult<CheckoutSession>;
    createCheckoutSessionIsError(graphQl.errors as GraphQLError[]);
  }
};
